import api from "apis/customerConfiguration";
import {
  REQUEST_CUSTOMER_FORMS,
  RECEIVE_CUSTOMER_FORMS,
  ERROR_CUSTOMER_FORMS,
  REQUEST_NOTIFICATION_TYPES,
  RECEIVE_NOTIFICATION_TYPES,
  ERROR_NOTIFICATION_TYPES,
  REQUEST_NOTIFICATION_METHODS,
  RECEIVE_NOTIFICATION_METHODS,
  ERROR_NOTIFICATION_METHODS,
  REQUEST_NOTIFICATION_LETTERS,
  RECEIVE_NOTIFICATION_LETTERS,
  ERROR_NOTIFICATION_LETTERS,
} from "typeConstants";
import { HTTP_GET, WebApiReduxRequest } from "tools/webservice";

export const getCustomerForms = customerNumber => WebApiReduxRequest(
  REQUEST_CUSTOMER_FORMS,
  RECEIVE_CUSTOMER_FORMS,
  ERROR_CUSTOMER_FORMS,
  HTTP_GET,
  api.getActiveForms(customerNumber),
);

export const getNotificationTypes = () => WebApiReduxRequest(
  REQUEST_NOTIFICATION_TYPES,
  RECEIVE_NOTIFICATION_TYPES,
  ERROR_NOTIFICATION_TYPES,
  HTTP_GET,
  api.notificationTypes(),
);

export const getNotificationMethods = () => WebApiReduxRequest(
  REQUEST_NOTIFICATION_METHODS,
  RECEIVE_NOTIFICATION_METHODS,
  ERROR_NOTIFICATION_METHODS,
  HTTP_GET,
  api.notificationMethods(),
);

export const getNotificationLetters = () => WebApiReduxRequest(
  REQUEST_NOTIFICATION_LETTERS,
  RECEIVE_NOTIFICATION_LETTERS,
  ERROR_NOTIFICATION_LETTERS,
  HTTP_GET,
  api.notificationLetters(),
);